import ShoppingAvatar from './ShoppingAvatar';

export default ShoppingAvatar;
